import { useEffect, useState } from 'react';
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Typography, Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { officerNav } from '../components/officerNav';
import api from '../services/api';

// Lists tenders that are published or closed (i.e. have reached/neared bidding),
// so the officer can pick one to view and open its bids.
export default function BidOpeningList() {
  const navigate = useNavigate();
  const [tenders, setTenders] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get('/tenders', { params: { pageSize: 100 } });
      // Only tenders that can have bids: published or closed.
      setTenders(data.data.filter((t) => t.status === 'PUBLISHED' || t.status === 'CLOSED'));
    })();
  }, []);

  return (
    <DashboardLayout nav={officerNav} title="Bid Opening">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a tender to view the bids received and open them at the scheduled time.
      </Typography>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Reference</TableCell><TableCell>Title</TableCell>
              <TableCell>Deadline</TableCell><TableCell>Opening date</TableCell>
              <TableCell>Status</TableCell><TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tenders.map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>{t.reference}</TableCell>
                <TableCell>{t.title}</TableCell>
                <TableCell>{t.submissionDeadline ? new Date(t.submissionDeadline).toLocaleDateString('en-GB') : '—'}</TableCell>
                <TableCell>{t.bidOpeningDate ? new Date(t.bidOpeningDate).toLocaleDateString('en-GB') : '—'}</TableCell>
                <TableCell><Chip size="small" label={t.status} /></TableCell>
                <TableCell align="right"><Button size="small" onClick={() => navigate(`/officer/bid-opening/${t.id}`)}>View bids</Button></TableCell>
              </TableRow>
            ))}
            {tenders.length === 0 && (
              <TableRow><TableCell colSpan={6}><Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>No tenders available for bid opening yet.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </DashboardLayout>
  );
}
